import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  InputLabel, Button, FormControl, Select, MenuItem, FormHelperText
} from '@material-ui/core'
import AddBoxIcon from '@material-ui/icons/AddBox'
import { ButtonLoader } from '../components/Loader/ButtonLoader'
import { ItemsListConsumer, ItemsListProvider } from '../context/ItemsListContext'
import AddNewForm from './EntityAddForm'
import AddNewDialog from '../components/Dialog/AddNewDialog'

const FormEntityListField = ({ formActions, classes, name, labelKey, list, entityName, required, row, addMore, withKeyNext, entityKey = 'name', locale, displayEmpty = false, returnedObjectKey, updateParentEntity, disabled }) => {
  const handleSelectChange = (event, listingData) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    formActions.setFieldValue(name, event.target.value.toString())
    if (!!returnedObjectKey) {
      let value = listingData.filter(item => item.key.toString() === event.target.value.toString())
      formActions.setFieldValue(returnedObjectKey, !!value?.length ? value[0] : {})
    }
  }

  return (
    <ItemsListProvider entityName={entityName} listArr={list} all>
      <ItemsListConsumer>
        {({ listingData, listingLoading, openDialog, entityName, dialogActionSubmit, currentDialogAction, isDialogOpen, cancelDialog }) => (
          <div className={classes.FormItem + (!!row ? ` ${classes.FormRow}` : '')}>
            <InputLabel id={name + '-label'} htmlFor={name}><FormattedMessage id={labelKey}/>{!!required &&
            <span className={'required'}>*</span>}:</InputLabel>
            <FormControl variant="outlined" className={classes.FormItemSelect}>
              {!!listingLoading && <ButtonLoader loading={true}/>}
              <Select
                fullWidth
                displayEmpty={displayEmpty}
                labelId={name + '-label'}
                id={name}
                name={name}
                disabled={disabled}
                margin={'dense'}
                variant='outlined'
                MenuProps={{ disableScrollLock: true }}
                value={!!listingData?.length ? formActions.values[name] : ''}
                // label={intl.formatMessage({ id: 'Fields.Labels.Role' })}
                onChange={(e) => handleSelectChange(e, listingData)}
                onBlur={formActions.handleBlur}
                error={formActions.errors[name] && formActions.touched[name] !== undefined}
              >
                {!!displayEmpty && <MenuItem value={''}><FormattedMessage id={labelKey}/></MenuItem>}
                {!!listingData?.length && listingData.map((item, index) => (
                  <MenuItem key={index} value={item.key}>
                    <div
                      className={((!!locale && !!item[`desc_${locale}`]) || !!item.desc) ? classes.SelectItemWithTitle : ''}>
                      <span className={'title'}>{!!locale ? item[`${entityKey}_${locale}`] : item[entityKey]}
                        {!!withKeyNext && <span> (<strong>{item.key}</strong>)</span>}</span>
                      {!!locale && !!item[`desc_${locale}`] ?
                        <span className={'description'}>{item[`desc_${locale}`]}</span> : (!!item.desc &&
                          <span className={'description'}>{item.desc}</span>)}
                    </div>
                  </MenuItem>))}
              </Select>
              {formActions.errors[name] && formActions.touched[name] && (
                <FormHelperText error={true}>{formActions.errors[name]}</FormHelperText>
              )}
            </FormControl>
            {!!addMore && !disabled && <div className={classes.FormRow}>
              <Button size={'small'} disableRipple color={'secondary'} onClick={() => openDialog()}
                      disabled={!!listingLoading} className={classes.addNewEntityButton}>
                <AddBoxIcon/>
                <FormattedMessage id={`EntityList.${entityName}.dialogTitle.create`}/>
              </Button>
              <AddNewDialog
                children={<AddNewForm entityName={entityName}
                                      currenciesKeys={(entityName === 'currency') ? listingData?.map(item => item?.key) : null}
                                      onSubmit={dialogActionSubmit}
                                      currentAction={currentDialogAction}
                                      updateParentEntity={updateParentEntity}
                                      cancelDialog={cancelDialog}/>}
                dialogAction={currentDialogAction}
                DialogTitle={<FormattedMessage
                  id={`EntityList.${entityName}.dialogTitle.${currentDialogAction}`}/>}
                isDialogOpen={isDialogOpen}
                cancelDialog={cancelDialog}
              />

            </div>
            }
          </div>
        )}
      </ItemsListConsumer>
    </ItemsListProvider>
  )
}

export default FormEntityListField
